<template>
  <div>
    <v-card v-if="false" flat> <ai-fake /> </v-card>
    <v-card flat> <ai-mail /> </v-card>
  </div>
</template>

<script>
import aiFake from "@/components/ai/aiFake.vue"
import aiMail from "@/components/ai/aiMail.vue"

export default {
  components: {
    aiFake,
    aiMail,
  },
  data() {
    return {}
  },
  async created() {},
  methods: {},
}
</script>
